
import Header from "../Common/Header";
import Footer from "../Common/Footer";

function Applyloan() {
  return (
    <>
    <Header />
    {/* start Banner Two Area */}
    <div className="banner-two-area">
      <div className="container-fluid">
        <div className="row align-items-center">
         
          <div className="col-lg-7">
          <div className="row align-items-center">
         
         <div className="col-lg-4">
         <img src="assets/images/banner/hp-banner-img.svg" alt="banner-1" />
                        </div>
                        <div className="col-lg-12">
            <div className="single-banner-two-content">
              <span>Live Your Dream</span>
              <h1>You can get a professional loan instantly.</h1>
             
            
            </div>
          </div>

          </div>
          </div>
          <div className="col-lg-5">
          <div className="contact-form">
  <form id="contactForm">
    <div className="row">
    <div className="col-lg-12 col-md-6">
        <strong>Please fill this form</strong>
        </div>
      <div className="col-lg-12 col-md-6">
        <div className="form-group">
          <input
            type="text"
            id="name"
            className="form-control"
            placeholder="Name"
            required=""
            data-error="Please enter your name"
          />
          <div className="help-block with-errors" />
        </div>
      </div>
      <div className="col-lg-12 col-md-6">
        <div className="form-group">
          <input
            type="text"
            id="email"
            className="form-control"
            placeholder="Mobile Number"
            required=""
            data-error="Please enter your mobile number"
          />
          <div className="help-block with-errors" />
        </div>
      </div>
      <div className="col-lg-12 col-md-6">
        <div className="form-group">
        <select className="form-control">
        <option>Employment Type</option>
            <option>Salaried</option>
            <option>Self Employed</option>
            <option>Business Owner</option>
        </select>
          <div className="help-block with-errors" />
        </div>
      </div>
      <div className="col-lg-12 col-md-6">
        <div className="form-group">
        <select className="form-control">
        <option>In hand Salary</option>
            <option>Less than 10000</option>
            <option>10,000-20,000</option>
            <option>20,000-35,000</option>
            <option>35,000-50,000</option>
            <option>35,000-50,000</option>
            <option>50,000+</option>
        </select>
          <div className="help-block with-errors" />
        </div>
      </div>
      <div className="col-lg-12 col-md-6">
        <div className="form-group">
          <input
            type="text"
            id="Subject"
            placeholder="Pincode"
            required=""
            data-error="Please enter your Pincode"
            className="form-control"
          />
          <div className="help-block with-errors" />
        </div>
      </div>
    
      <div className="col-lg-12 col-md-12">
        <button type="submit" className="default-btn">
          Submit Now
        </button>
        <div id="msgSubmit" className="h3 text-center hidden" />
        <div className="clearfix" />
      </div>
    </div>
  </form>
</div>

          </div>
        </div>
      </div>
      <div className="banner-two-shape">
        <img src="assets/images/banner/banner-2-img-3.webp" alt="banner3" />
      </div>
    </div>
    {/* End Banner Two Area */}
    <Footer />
  </>
  
  );
}

export default Applyloan;
